<app-toast></app-toast>

<div class="grid grid-cols-2 h-screen w-full mobile:flex">

    <!-- Left panel -->
    <div class="bg-primary-800 flex flex-col gap-5 mobile:hidden">
        <div class="flex-grow flex justify-end items-end">
            <img src="assets/images/signup-page/dashboard-example.png"
                alt="{{ 'auth.dashboard_example_image' | transloco }}"
                class="w-[80%] max-w-[1440px] h-auto max-h-[960px] pointer-events-none select-none" />
        </div>
    </div>

    <!-- Right panel -->
    <div class="bg-white p-4 z-40 px-[5%] flex flex-col h-full mobile:px-7 mobile:w-screen">

        <div class="flex w-full items-center justify-between mobile:justify-center mobile:mt-10">
            <app-logo></app-logo>
        </div>

        <div class="flex-grow flex flex-col justify-center items-center">
            <div class="max-w-screen-sm w-full self-center mt-[5vh] mobile:mt-5">

                <!-- Headline -->
                <h1 class="text-5xl font-bold mobile:text-xl mobile:mt-[10vh]">
                    {{ 'settings.account_deletion.title' | transloco }}
                </h1>

                <p class="mt-3 mobile:text-base text-gray-700">
                    {{ 'settings.account_deletion.desc' | transloco }}
                </p>

                <!-- Optional date -->
                <div *ngIf="deletionDateLabel" class="mt-4 text-sm text-gray-700">
                    <span class="font-semibold">{{ 'settings.account_deletion.scheduled_for' | transloco }}</span>
                    <span> {{ deletionDateLabel }}</span>
                </div>

                <!-- Confirmation UI -->
                <div class="mt-10 p-4 border border-gray-200 rounded-lg">

                    <!-- Step 1 -->
                    <div *ngIf="confirmStep === 1">
                        <p class="text-sm text-gray-800">
                            {{ 'settings.account_deletion.reactivate_step1' | transloco }}
                        </p>

                        <div class="mt-5">
                            <app-primary-button
                                buttonText="{{ 'settings.account_deletion.reactivate_button' | transloco }}"
                                [isDisabled]="isLoading" (buttonClick)="startDoubleConfirm()">
                            </app-primary-button>
                        </div>
                    </div>

                    <!-- Step 2 (double confirm) -->
                    <div *ngIf="confirmStep === 2">
                        <p class="text-sm text-gray-800">
                            {{ 'settings.account_deletion.reactivate_step2' | transloco }}
                        </p>

                        <div class="mt-4 flex items-center gap-2">
                            <input type="checkbox" checked="checked" [(ngModel)]="confirmChecked"
                                class="checkbox border-border [--chkbg:theme(colors.primary.1000)] [--chkfg:theme(colors.white)] checked:border-primary" />
                            <label for="confirmCheck" class="text-sm text-gray-700">
                                {{ 'settings.account_deletion.confirm_checkbox' | transloco }}
                            </label>
                        </div>

                        <div class="mt-5 flex gap-3 items-end">
                            <div class="h-[45px] w-[200px]">
                                <app-custom-button buttonText="{{ 'shared.cancel' | transloco }}"
                                    backgroundColor="bg-[#FFFFFF]" textColor="text-secondary"
                                    borderColor="border-secondary" hoverBackgroundColor="hover:bg-secondary"
                                    hoverBorderColor="hover:border-secondary"
                                    (buttonClick)="cancelDoubleConfirm()"></app-custom-button>
                            </div>

                            <div class="h-[45px] w-[200px]">
                                <app-custom-button
                                    buttonText="{{ 'settings.account_deletion.confirm_reactivate_button' | transloco }}"
                                    backgroundColor="bg-primary" textColor="text-white"
                                    [isDisabled]="isLoading || !confirmChecked" borderColor="border-primary"
                                    hoverBackgroundColor="hover:bg-primary-1200"
                                    hoverBorderColor="hover:border-primary-1200"
                                    disabledBackgroundColor="bg-primary-600" disabledBorderColor="border-primary-600"
                                    (buttonClick)="reactivateAccount()"></app-custom-button>
                            </div>
                        </div>
                    </div>

                </div>

                <!-- Help links -->
                <div class="mt-6">
                    <p class="font-normal mt-2 text-sm text-gray-700">
                        {{ 'settings.account_deletion.secure_account_hint' | transloco }}
                    </p>

                    <!-- Sign Out -->
                    <div class="mt-6 text-sm">
                        <a routerLink="/auth/logout" class="text-primary hover:underline cursor-pointer">{{
                            'auth.mfa.back_to_sign_in' |
                            transloco }}</a>
                    </div>
                </div>

            </div>
        </div>

    </div>
</div>